<template>
  <div v-if="issue && issue.id" class="modal-content">
    <div class="modal-header">
      <h5 id="modalLabel" class="modal-title">
        Repuestos
      </h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="container-fluid">
        <div v-for="(product, index) in issueProductList.productLines" :key="index" class="row row-products">
          <div class="col-4">
            {{product.product.name}}
          </div>
          <div class="col-4">
            <span v-if="edit[product.id] || product.product.priceType === 'SETTEABLE' && !product.price" class="row">
              <input v-model="product.priceClone" type="number" placeholder="Precio" class="form-control col-8">
              <button class="btn btn-success btn-sm col-4" @click="setProductPrice(product)">Guardar</button>
            </span>
            <span v-else-if="product.product.priceType === 'SETTEABLE'">
              <span class="col-8">$ {{product.price}}</span>
              <button v-if="issue.active" class="btn btn-warning btn-sm col-4" @click="toggleEditMode(product)">Cambiar</button>
            </span>
            <span v-else>$ {{product.price}}</span>
          </div>
          <div class="col-2 text-center">
            <button v-if="issue.active" type="button" class="btn btn-danger" @click="removeProduct(product.id)">
              Quitar
            </button>
          </div>
        </div>
        <hr v-if="totalPrice > 0">
        <div v-if="totalPrice > 0" style="border-bottom:1px solid #CACACA;padding-bottom: 15px;" class="row row-products">
          <div class="col-4">
            <b>Precio Total</b>
          </div>
          <div class="col-8">
            <b>$ {{totalPrice}}</b>
          </div>
        </div>
      </div>
      <div v-if="issue.active" class="container-fluid">
        <div class="row">
          <h5>
            Agregar Repuestos
          </h5>
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Busque producto aquí." @keyup="getProducts">
            <div class="input-group-append">
              <button class="btn btn-secondary" @click="forceGetProducts">
                Traer más repuestos
              </button>
            </div>
          </div>
        </div>
        <div style="margin-top:10px">
          <div class="row">
            <h6 class="col-12">
              O Agregarlo aqui
            </h6>
          </div>
          <div class="row">
            <div class="col-5">
              <div class="input-group">
                <div class="input-group-prepend">
                  <label class="input-group-text" for="cost">Costo</label>
                </div>
                <div class="input-group-prepend">
                  <label class="input-group-text" for="cost">$</label>
                </div>
                <input id="cost" v-model="draftProd.cost" type="number" placeholder="Costo" class="form-control" name="cost">
              </div>
            </div>
            <div class="col-5">
              <div class="input-group">
                <div class="input-group-prepend">
                  <label class="input-group-text" for="price">Precio</label>
                </div>
                <div class="input-group-prepend">
                  <label class="input-group-text" for="price">$</label>
                </div>
                <input id="price" v-model="draftProd.price" placeholder="Precio al Cliente" class="form-control" name="price">
              </div>
            </div>
            <button class="btn btn-success col-2" @click="createProductOnTheFly">
              Agregarlo
            </button>
          </div>
        </div>

        <hr>
        <div class="container-fluid">
          <div v-for="(product, index) in searchProducts" :key="index" class="row row-products">
            <div class="col-4">
              {{product.description}}
            </div>
            <div class="col-4">
              <span v-if="product.priceType === 'SETTEABLE'">
                Precio Variable
              </span>
              <span v-else>$ {{product.price}}</span>
            </div>
            <div class="col-2 text-center">
              <button type="button" class="btn btn-success" @click="addProduct(product)">
                Agregar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-dismiss="modal">
        OK
      </button>
    </div>
  </div>

  <div v-else>
    <p>Vacío o sin seleccionar.</p>
  </div>
</template>

<script>
import ProductService from '@/services/product.service';

export default {
    name: 'IssueProductList',
    props: {
        issue: Object
    },
    data() {
        return {
            products: [],
            draftProd: {
                description: 'Generico',
                price: '',
                cost: '',
                priceType: 1,
                code: '-1'
            },
            searchProducts: [],
            issueProductList: {},
            totalPrice: 0,
            edit: {}
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        }
    },
    // This was loading when the Ticket was accessed, not needed if we aren't going to use it.
    // created() {
    //     this.initProducListComponent();
    // },
    methods: {
        initProducListComponent() {
            this.edit = {};
            this.getProductList();
        },
        getProductList() {
            var self = this;
            self.totalPrice = 0;
            ProductService.getProductList(this.issue.id).then(
                response => {
                    this.issueProductList = response.data;
                    this.issueProductList.productLines.forEach(plist => {
                        self.totalPrice += plist.price;
                    });
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        forceGetProducts() {
            this.setProductList();
        },
        setProductList(value) {
            // only get active products here.
            ProductService.getProducts(true).then(
                response => {
                    this.products = response.data;
                    if (value) {
                        this.searchProducts = this.products.filter(product => {
                            return product.name.toLowerCase().includes(value.toLowerCase()) ||
                            product.description.toLowerCase().includes(value.toLowerCase()) ||
                                product.code.toLowerCase().includes(value.toLowerCase());
                        });
                    } else {
                        this.searchProducts = this.products;
                    }
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        getProducts(e) {
            if (e.target.value.length > 2) {
                if (!this.products.length) {
                    this.setProductList(e.target.value);
                } else {
                    this.searchProducts = this.products.filter(product => {
                        return product.description.toLowerCase().includes(e.target.value.toLowerCase());
                    });
                }
            }
        },
        createProductOnTheFly() {
            var self = this;
            ProductService.saveProduct(this.draftProd)
                .then(response => {
                    this.draftProd.id = response.data.id;

                    self.addProduct(response.data);
                    setTimeout(function forceControl() {
                        self.draftProd = {
                            description: 'Generico',
                            price: '',
                            cost: '',
                            priceType: 1,
                            code: '-1'
                        };
                    }, 1000);
                },
                error => {
                    console.log(error.response && error.response.data ||
                        error.message || error.toString());
                });
        },
        addProduct(product) {
            var self = this;
            ProductService.postProductsList(this.issue.id, product).then(
                response => {
                    this.issueProductList = response.data;
                    self.totalPrice = 0;
                    this.issueProductList.productLines.forEach(plist => {
                        self.totalPrice += plist.price;
                    });
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        setProductPrice(product) {
            product.price = product.priceClone;
            ProductService.updateProductListItem(product.id, product).then(
                response => {
                    // done!
                    this.edit[product.id] = false;
                    this.getProductList();
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        toggleEditMode(product) {
            this.edit[product.id] = true;
            this.getProductList();
        },
        removeProduct(productId) {
            var self = this;
            ProductService.removeProductFromProductList(this.issue.id, productId).then(
                response => {

                    this.issueProductList.productLines = this.issueProductList.productLines.filter(product => {
                        return product.id !== productId;
                    });
                    self.totalPrice = 0;
                    this.issueProductList.productLines.forEach(plist => {
                        self.totalPrice += plist.price;
                    });
                    // remove from the represented list.
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        }
    /* eslint-disable no-console */
    }
};
</script>
<style lang="scss">
.row-products {
    margin-bottom: 10px;
}
</style>
